import React from "react";
import styles from "./Footer.module.css";
import { openCookieSettings } from "../../utils/cookieEvents";
import { openCookiesPolicy } from "../../utils/cookieEvents";
import { openPrivacyPolicy } from "../../utils/cookieEvents";

export default function Footer() {
  return (
    <footer id="footerOfWeb">
      <div className={styles.footerContainer}>
        <div className={styles.footerColumn}>
          <h2>ArtKoz</h2>
          <p>
            Tworzymy strony WWW, szkolimy i wspieramy w świecie technologii.
          </p>
        </div>

        <div className={styles.footerColumn}>
          <h3>Firma</h3>
          <ul>
            <li>
              <a href="/#aboutUs">O nas</a>
            </li>
            <li>
              <a href="/#portfolio">Portfolio</a>
            </li>
            <li>
              <a href="/#service">Usługi</a>
            </li>
            <li>
              <a href="/#cooperation">Współpraca</a>
            </li>
            <li>
              <a href="/#contact">Kontakt</a>
            </li>
          </ul>
        </div>

        <div className={styles.footerColumn}>
          <h3>Usługi</h3>
          <ul>
            <li>Projektowanie stron WWW</li>
            <li>SEO</li>
            <li>Projkety graficzne</li>
            <li>Szkolenia</li>
            {/* <li>Autorskie produkty</li> */}
          </ul>
        </div>

        <div className={styles.footerColumn}>
          <h3>Kontakt</h3>
          <ul>
            <li>
              <i className={`${styles.contactIcon} fa fa-mobile`} />
              <a href="tel:+48123456789" className={styles.phoneLink}>
                +48 734 959 867
              </a>
            </li>
            <li>
              <i className={`${styles.contactIcon} fa fa-envelope`} />
              biuro.artkoz@gmail.com
            </li>
            <li>
              {/* <i className={`${styles.contactIcon} fa fa-building-o`} /> */}
              <p>
                <i className={`${styles.contactIcon} fa fa-building`} />
                NIP: 7133146485
              </p>
              <p className={styles.regon}>REGON: 545221911</p>
            </li>
          </ul>
          {/* <h3>Newsletter</h3>
          <form id="newsletter-form">
            <input type="email" placeholder="Twój e-mail" required />
            <button type="submit">Zapisz się</button>
          </form>
          <p id="newsletter-msg"></p>*/}
        </div>
      </div>
      <div className={styles.footerBottom}>
        <div className={styles.socialBar}>
          <div className={styles.barContent}>
            <div className={styles.line} />
            <div className={styles.icons}>
              <a
                href="/#"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram" />
              </a>
              <a
                href="https://www.facebook.com/artkozit"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f" />
              </a>
              {/* <a href="#" aria-label="X (Twitter)" target="_blank">
                <i className="fab fa-x-twitter" />
              </a>
              <a href="#" aria-label="YouTube" target="_blank">
                <i className="fab fa-youtube" />
              </a> */}
              <a href="/#" aria-label="LinkedIn" target="_blank">
                <i className="fab fa-linkedin-in" />
              </a>
              {/* <a href="#" aria-label="TikTok" target="_blank">
                <i className="fab fa-tiktok" />
              </a> */}
            </div>
            <div className={styles.line} />
          </div>
        </div>
        <p>© 2026 ArtKoz. Wszelkie prawa zastrzeżone.</p>
        <div className={styles.footerBtn}>
          <button
            id="manage-cookies"
            type="button"
            className={styles.btnChangeSettings}
            onClick={openCookieSettings}
          >
            Zmień ustawienia cookies
          </button>
          <button
            id="manage-cookies"
            type="button"
            className={`${styles.btnChangeSettings} ${styles.policyLinks}`}
            onClick={openCookiesPolicy}
          >
            Polityka cookies
          </button>
          <button
            id="policyPrivacyFooter"
            type="button"
            className={`${styles.btnChangeSettings} ${styles.policyLinks}`}
            onClick={openPrivacyPolicy}
          >
            Polityka prywatności
          </button>
        </div>
      </div>
    </footer>
  );
}
